import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "indicators" }
const _hoisted_2 = {
  key: 0,
  class: "economicsTypeBlock"
}
const _hoisted_3 = { class: "indicators__header" }
const _hoisted_4 = {
  key: 0,
  class: "indicators__source"
}
const _hoisted_5 = { class: "indicators__list align-center mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionTitle = _resolveComponent("SectionTitle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.list?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_SectionTitle, { text: $props.title }, null, 8, ["text"]),
            ($props.source)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Источник: " + _toDisplayString($props.source), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.id,
                class: "indicators__itemCustom"
              }, [
                _renderSlot(_ctx.$slots, "item", { item: item }, undefined, true)
              ]))
            }), 128))
          ]),
          _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}